/**
 * ImageBlock: `image` content block.
 *
 * data: { url, alt, caption? }
 *
 * A single authored image with an optional caption. Degrades gracefully: no
 * `url` renders nothing. `alt` defaults to an empty string (decorative) when
 * the author omits it, never an undefined alt attribute.
 *
 * Round-3 review finding 2: client-side URL allowlist mirrors HeroBlock /
 * CtaButtonBlock so the four author-content blocks with URLs defend
 * themselves uniformly. The server's validateBlockUrls is the real
 * security boundary (bad URLs never persist), but a future code path that
 * bypasses the server validator (raw migration, admin tool, a row that
 * pre-existed the validator) would otherwise slip a data:/javascript:
 * src through to <img>.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Figure } from 'react-bootstrap';

import { isAllowedImageUrl } from '../utils/urlValidator';

export default function ImageBlock({ data }) {
    const { url, alt, caption } = data || {};

    if (!url || !isAllowedImageUrl(url)) {
        return null;
    }

    return (
        <Figure className="d-block text-center w-100 mb-0">
            <Figure.Image
                src={url}
                alt={alt || ''}
                className="content-image rounded"
            />
            {caption && (
                <Figure.Caption className="text-muted mt-2">
                    {caption}
                </Figure.Caption>
            )}
        </Figure>
    );
}

ImageBlock.propTypes = {
    data: PropTypes.shape({
        url: PropTypes.string,
        alt: PropTypes.string,
        caption: PropTypes.string,
    }),
};

ImageBlock.defaultProps = {
    data: {},
};
